const StatusOsEnum = Object.freeze({
  ABERTA: 'A',
  ENCERRADA: 'E',
  REABERTA: 'R',
  CANCELADA: 'C',
  AG_APROVACAO_EXTERNA: 'X',
  AG_OPERADOR: 'T',
  AG_SINISTRO: 'S',
  AG_APROVACAO_PNEUS: 'P',
  AG_LIBERACAO: 'L',
  AG_CANCELAMENTO: 'I'
})

export const STATUS_OS_BLOQUEADOS = Object.freeze([
  StatusOsEnum.ENCERRADA,
  StatusOsEnum.CANCELADA,
  StatusOsEnum.AG_CANCELAMENTO
])

export default StatusOsEnum
